var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticClass: "wrapper d-flex flex-column align-center justify-center pa-4",
    attrs: {
      "color": "transparent",
      "height": _vm.styles[_vm.size].wrapperWidth,
      "width": _vm.styles[_vm.size].wrapperWidth
    }
  }, [_c('v-img', {
    staticClass: "avatar-image",
    attrs: {
      "src": _vm.headshotData.headshot,
      "height": _vm.styles[_vm.size].imageWidth,
      "max-height": _vm.styles[_vm.size].imageWidth,
      "max-width": _vm.styles[_vm.size].imageWidth,
      "width": _vm.styles[_vm.size].imageWidth
    }
  }), _c('h5', {
    staticClass: "font-weight-bold primary--text mt-4 text-no-wrap",
    class: ("text-" + (_vm.styles[_vm.size].nameTextSize))
  }, [_vm._v(_vm._s(_vm.headshotData.name))]), _c('p', {
    staticClass: "ma-0",
    class: ("text-" + (_vm.styles[_vm.size].titleTextSize))
  }, [_vm._v(_vm._s(_vm.headshotData.title))])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }